var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75532 3C3.13536 3 1.01074 5.216 1.01074 7.95C1.01074 10.157 1.84104 15.395 10.014 20.69C10.1604 20.7839 10.3285 20.8335 10.4999 20.8335C10.6713 20.8335 10.8393 20.7839 10.9857 20.69C19.1587 15.395 19.989 10.157 19.989 7.95C19.989 5.216 17.8644 3 15.2445 3C12.6245 3 10.4999 6 10.4999 6C10.4999 6 8.37527 3 5.75532 3Z",
    stroke: "#3CB4E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.7071,
    y1: 0.707107,
    x2: 1.70711,
    y2: 21.7071,
    stroke: "#3CB4E5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFavorite);
export default __webpack_public_path__ + "static/media/removeFavorite.2c397c62c867be8a929959df363cb27c.svg";
export { ForwardRef as ReactComponent };